const Genesis = require("../Genesis.js")
let PropertyAutoComplete = require("./assetsearch.js");
export class ISiteMobileAssetSearchPage {
    constructor() { }
    public Init() {
        PropertyAutoComplete();
    }
};